import React from 'react'
import { ZariContext } from '_zari/context'
import { Portlet, Table } from '_zari/core'
import * as FamiliaCrud from 'services/familia.service'
import NuevaFamiliaModal from '../modals/nuevaFamiliaModal'

const portletBreadcrumbs = [{ name: 'Familias' }]

const tableHeaderRows = [
  {
    label: 'NOMBRE',
    filter: {
      type: 'text',
      name: 'nom'
    }
  },
  {
    label: 'CATEGORIA',
    filter: {
      type: 'select2',      // 👈 aquí usas select2 para autocompletado
      name: '_idCategoria', // 👈 mandamos el idCategoria al backend
      service: 'categorias' // 👈 aquí le dices que la data viene del servicio de categorias
    }
  },
  {
    label: ''
  }
]

const ListaFamiliasPage = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)
  const [editData, seteditData] = React.useState({ nombre: '', title: 'Nuevo', id: '', _idCategoria: '' })
  const tablaRef = React.useRef(null)

  const [mostrarNuevaFamiliaModal, setMostrarNuevaFamiliaModal] = React.useState(false)

  const activarModal = () => setMostrarNuevaFamiliaModal(true)

  const clickNuevo = React.useCallback(() => {
    seteditData({ nombre: '', title: 'Nueva Familia', id: '', _idCategoria: '' })
    activarModal()
  }, [])

  const clickEditar = React.useCallback(
    async ({ _id }) => {
      await FamiliaCrud.getFamilia(_id)
        .then(({ data }) => {
            
          seteditData({ nombre: data.nombre, title: 'Editar', id: _id, _idCategoria: data._idCategoria })
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
      activarModal()
    },
    [__zariContext]
  )

  const clickEliminar = React.useCallback(
    async ({ _id }) => {
      await FamiliaCrud.eliminarFamilia(_id)
        .then(() => {
          __zariContext.snack('success', 'Registro eliminado')
          tablaRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  return (
    <>
      <>
        <Portlet>
          <Portlet.Header title='Familias' breadcrumbs={portletBreadcrumbs} buttons={[{ name: 'Nuevo', onClick: clickNuevo }]} />
          <Portlet.Body>
            <Table.ServerSide
              ref={tablaRef}
              useNest={true}
              useFilters={true}
              url='/familias'
              headRows={tableHeaderRows}
              rowTemplate={row => (
                <Table.Row hover key={row._id}>
                  <Table.Cell>{row.nombre || '--'}</Table.Cell>
                  <Table.Cell>{row.categoria || '--'}</Table.Cell>
                  <Table.Cell>
                    <Table.Dropdown>
                      {({ handleClose }) => [
                        <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditar({ _id: row._id })}>
                          Editar
                        </Table.Dropdown.Item>,
                        <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickEliminar({ _id: row._id })}>
                          Eliminar
                        </Table.Dropdown.Item>
                      ]}
                    </Table.Dropdown>
                  </Table.Cell>
                </Table.Row>
              )}
            />
          </Portlet.Body>
        </Portlet>
      </>
      {mostrarNuevaFamiliaModal && (
        <NuevaFamiliaModal
          show={mostrarNuevaFamiliaModal}
          handleClose={() => setMostrarNuevaFamiliaModal(false)}
          editData={editData}
          tablaRef={tablaRef}
        />
      )}
    </>
  )
}

export default ListaFamiliasPage
